<script type="ts">
	import Time from 'svelte-time';
	import { createEventDispatcher } from 'svelte';

	import Button from '../shared/Button.svelte';
	import { fly, fade } from 'svelte/transition';
	import InputPhone from '../shared/InputPhone.svelte';
	import InputDate from '../shared/InputDate.svelte';
	import { createForm } from 'svelte-forms-lib';
	import * as yup from 'yup';
	import es from 'yup-es';
	import { storeSettings } from '../../store/StoreSettings';
	import { get } from 'svelte/store';
	yup.setLocale(es);

	const publicKey = get(storeSettings).publicKey;
	const buttonText = get(storeSettings).buttonText;
	const invitationCode = get(storeSettings).invitationCode;
	const ticketTypeCode = get(storeSettings).ticketTypeCode;
	const autoValidationCode = get(storeSettings).autoValidationCode;

	const dispatch = createEventDispatcher();

	let loading: boolean = false;

	const { form, errors, state, handleChange, handleSubmit } = createForm({
		initialValues: {
			name: '',
			lastname: '',
			email: '',
			emailConfirm: '',
			phone: {
				countryCode: 'UY',
				national: '',
				international: '',
				validated: false,
				type: null
			},
			birthdate: null
		},
		validationSchema: yup.object().shape({
			name: yup.string().required().label('Nombre'),
			lastname: yup.string().required().label('Apellido'),
			email: yup.string().email().required().label('Email'),
			emailConfirm: yup
				.string()
				.email()
				.required()
				.label('Confirmar email')
				.oneOf([yup.ref('email'), null], 'Los emails no coinciden'),
			phone: yup.object({
				national: yup.string().required().label('Teléfono'),
				validated: yup.boolean().oneOf([true], 'El teléfono no es válido'),
				type: yup.string().oneOf(['mobile'], 'El teléfono debe ser celular')
			}),
			birthdate: yup.date().required().label('Fecha de nacimiento')
		}),

		onSubmit: async (values) => {
			if (!loading) {
				loading = true;
				let formData = {
					invitationCode,
					ticketTypeCode,
					autoValidationCode,
					holder: {
						name: values.name,
						lastname: values.lastname,
						email: values.email,
						phone: values.phone,
						birthdate: values.birthdate
					}
				};
				// post formData to api widgets/courtesyRequest
				const res = await fetch(`API_URL/courtesyRequest`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						publicKey: publicKey
					},
					body: JSON.stringify(formData)
				});

				dispatch('submited', res.status == 200 ? true : false);

				loading = false;
			}
		}
	});
</script>

<div
	on:introstart
	on:outroend
	in:fade
	aria-labelledby="modal-title"
	role="dialog"
	aria-modal="true"
>
	<form on:submit={handleSubmit}>
		<div class="mb-6">
			<label for="name" class="block text-sm font-medium text-gray-900 dark:text-gray-300"
				>Nombre</label
			>
			<div class="relative">
				<input
					type="text"
					class="w-full px-4 py-3 pr-12 text-sm border border-gray-200 rounded-lg "
					placeholder="Nombre"
					bind:value={$form.name}
				/>
			</div>
			{#if $errors.name}
				<small class="text-red-600">{$errors.name}</small>
			{/if}
		</div>
		<div class="mb-6">
			<label for="lastname" class="block text-sm font-medium text-gray-900 dark:text-gray-300"
				>Apellido</label
			>
			<div class="relative">
				<input
					type="text"
					class="w-full px-4 py-3 pr-12 text-sm border border-gray-200 rounded-lg "
					placeholder="Apellido"
					bind:value={$form.lastname}
				/>
			</div>
			{#if $errors.name}
				<small class="text-red-600">{$errors.lastname}</small>
			{/if}
		</div>
		<div class="mb-6">
			<label for="email" class="block text-sm font-medium text-gray-900 dark:text-gray-300"
				>Email</label
			>
			<div class="relative">
				<input
					type="email"
					class="w-full px-4 py-3 pr-12 text-sm border border-gray-200 rounded-lg "
					placeholder="Email"
					bind:value={$form.email}
				/>
			</div>
			{#if $errors.email}
				<small class="text-red-600">{$errors.email}</small>
			{/if}
		</div>

		<div class="mb-6">
			<label for="emailConfirm" class="block text-sm font-medium text-gray-900 dark:text-gray-300"
				>Confirmar Email</label
			>
			<div class="relative">
				<input
					type="email"
					class="w-full px-4 py-3 pr-12 text-sm border border-gray-200 rounded-lg "
					placeholder="Confirmar Email"
					bind:value={$form.emailConfirm}
				/>
			</div>
			{#if $errors.emailConfirm}
				<small class="text-red-600">{$errors.emailConfirm}</small>
			{/if}
		</div>
		<div class="mb-6">
			<!-- {JSON.stringify($form.phone)} -->
			<InputPhone bind:value={$form.phone} placeholder="Teléfono celular" />
			{#if $errors['phone']['national']}
				<small class="text-red-600">{$errors['phone']['national']}</small>
			{/if}
			{#if $errors.phone.validated}
				<small class="text-red-600">{$errors.phone.validated}</small>
			{/if}
			{#if $errors.phone.type}
				<small class="text-red-600">{$errors.phone.type}</small>
			{/if}
		</div>
		<div class="mb-6">
			<InputDate bind:value={$form.birthdate} placeholder="Fecha de nacimiento" />
		</div>

		<div class="pt-3 mb-3">
			<Button {loading}>{buttonText}</Button>
		</div>
	</form>
</div>
